/* YOXYOX: Quick Chips drag/scroll helper
   - Fixes cases where horizontal scroll feels "stuck" on mobile emulators / trackpads.
   - Adds drag-to-scroll on desktop and improves touch scrolling.
*/

(function () {
  function enhance(el) {
    if (!el || el.dataset.yxQuickchipsReady === '1') return;
    el.dataset.yxQuickchipsReady = '1';

    // Visual hint for desktop
    el.style.cursor = 'grab';

    let isDown = false;
    let startX = 0;
    let startScrollLeft = 0;
    let moved = false;

    const getPageX = (e) => {
      if (e.touches && e.touches.length) return e.touches[0].pageX;
      return e.pageX;
    };

    const onDown = (e) => {
      // Only left mouse button
      if (e.type === 'mousedown' && e.button !== 0) return;

      isDown = true;
      moved = false;
      el.classList.add('yx-dragging');
      el.style.cursor = 'grabbing';

      startX = getPageX(e);
      startScrollLeft = el.scrollLeft;
    };

    const onMove = (e) => {
      if (!isDown) return;

      const x = getPageX(e);
      const dx = x - startX;
      if (Math.abs(dx) > 5) moved = true;

      el.scrollLeft = startScrollLeft - dx;

      // Prevent page scroll when user is dragging horizontally
      if (e.cancelable) e.preventDefault();
    };

    const onUp = () => {
      if (!isDown) return;
      isDown = false;
      el.classList.remove('yx-dragging');
      el.style.cursor = 'grab';

      // If user dragged, avoid accidental link click
      if (moved) {
        // Temporarily disable clicks for a tick
        el.classList.add('yx-no-click');
        setTimeout(() => el.classList.remove('yx-no-click'), 0);
      }
    };

    el.addEventListener('mousedown', onDown);
    el.addEventListener('mousemove', onMove);
    document.addEventListener('mouseup', onUp);

    // Touch
    el.addEventListener('touchstart', onDown, { passive: true });
    el.addEventListener('touchmove', onMove, { passive: false });
    el.addEventListener('touchend', onUp);
    el.addEventListener('touchcancel', onUp);

    // Stop accidental click after drag
    el.addEventListener('click', (e) => {
      if (el.classList.contains('yx-no-click')) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, true);
  }

  function init() {
    document.querySelectorAll('.yx-quickchips').forEach(enhance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
